type MimeMatch = {
  mime: string;
  detect: (bytes: Uint8Array) => boolean;
};

export function getFileTypeFromBuffer (
    buffer: ArrayBuffer | Uint8Array,
    allowedMimeTypes: string[]
): string | null {
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);

    const matchers: MimeMatch[] = [
        {
            mime: 'application/pdf',
            detect: (b) => matchesSignature(b, [0x25, 0x50, 0x44, 0x46]), // %PDF
        },
        {
            mime: 'text/csv',
            detect: (b) => isCSV(b),
        },
        {
            mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            detect: (b) => isXLSX(b),
        },
        {
            mime: 'application/vnd.ms-excel',
            detect: (b) => matchesSignature(b, [0xD0, 0xCF, 0x11, 0xE0]), // XLS
        },
        {
            mime: 'video/mp4',
            detect: (b) =>
                matchesSignature(b, [0x00, 0x00, 0x00]) &&
        (matchesSignature(b, [0x66, 0x74, 0x79, 0x70], 4) || // ftyp
          matchesSignature(b, [0x6D, 0x70, 0x34, 0x32], 4)), // mp42
        },
        {
            mime: 'image/jpeg',
            detect: (b) => matchesSignature(b, [0xFF, 0xD8, 0xFF]),
        },
        {
            mime: 'image/png',
            detect: (b) => matchesSignature(b, [0x89, 0x50, 0x4E, 0x47]),
        },
    ];

    for (const matcher of matchers) {
        if (allowedMimeTypes.includes(matcher.mime) && matcher.detect(bytes)) {
            return matcher.mime;
        }
    }

    return null;
}

// === Helpers ===

function matchesSignature (bytes: Uint8Array, signature: number[], offset = 0): boolean {
    return signature.every((b, i) => bytes[ i + offset ] === b);
}

function isCSV (bytes: Uint8Array): boolean {
    const text = safeDecode(bytes.subarray(0, 200));
    const hasComma = text.includes(',');
    // eslint-disable-next-line no-control-regex
    const hasControlChars = /[\x00-\x08]/.test(text);
    return hasComma && !hasControlChars;
}

function isXLSX (bytes: Uint8Array): boolean {
    if (!matchesSignature(bytes, [0x50, 0x4B, 0x03, 0x04])) {
        return false;
    }
    const text = safeDecode(bytes.subarray(0, 1000));
    return text.includes('[Content_Types].xml') && text.includes('xl/');
}

function safeDecode (data: Uint8Array): string {
    try {
        return new TextDecoder('utf-8', { fatal: false }).decode(data);
    } catch {
        return '';
    }
}
